export const DeleteFundActionTypes = {
  DELETE_FUND_LOADING: "DELETE_FUND_LOADING",
  DELETE_FUND_ERROR: "DELETE_FUND_ERROR",
  DELETE_FUND_SUCCESS: "DELETE_FUND_SUCCESS",
};
